import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBase } from 'src/app/_models/form-base';

@Component({
    selector: 'app-chip-radio-button',
    templateUrl: './chip-radio-button.component.html',
    styleUrls: ['./chip-radio-button.component.scss'],
    imports: [FormsModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChipRadioButtonComponent {
  /** Field form base for radio button group (required) */
  field = input<FormBase<string | number>>();

  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** The currently selected value (when loading existing data) */
  currentValue = input<string | number | undefined>(undefined);

  /** Is the input disabled? (optional) */
  isDisabled = input<boolean | undefined>(undefined);

  /** Is the label bold? (optional) */
  boldLabel = input<boolean>(true);

  /** Emitted when the radio selection changes */
  radioButtonChange = output<string>();

  updateValue(event: Event): void {
    const v = (event.target as HTMLInputElement).value;
    this.radioButtonChange.emit(v);
  }
}
